'use client';

import clsx from 'clsx';
import { FC } from 'react';
import { Container } from 'atoms/Container';
import { TileBannerContainer } from 'pages/StoryBlok/TileBanner';
import { AnimatePresence } from 'modules/framer-motion';
import { useMediaQuery } from 'modules/mui/hooks';
import { Column } from './Column';
import { AppearanceAnimationBlock } from './animation';
import { FlyoutProps } from './types';
import styles from './Flyout.module.css';

export const Flyout: FC<FlyoutProps> = ({ item }) => {
  const { isTablet } = useMediaQuery();

  const bannerConfig = item?.bannersSet?.[item.bannerIdx || 0];
  const bannerProps = typeof bannerConfig === 'string' ? null : bannerConfig;

  const flyoutColumns = item?.flyoutColumns;
  const isImage = bannerProps?.content?.type === 'image';
  const isWideImage = isImage && bannerProps?.content.wide_view;

  return (
    <div className={styles.root}>
      <AnimatePresence>
        {item?.flyoutColumns?.length ? (
          <AppearanceAnimationBlock
            className={styles.contentWrapper}
            keyVal="flyout-main"
          >
            <Container className={styles.flyoutContainer}>
              <ul className={styles.columns}>
                {flyoutColumns?.map((column) => (
                  <Column
                    key={column._uid}
                    columnItem={column}
                    itemParentTitle={item.title}
                  />
                ))}
                {bannerProps && isTablet && (
                  //Banner always stands in the last column
                  <AppearanceAnimationBlock
                    keyVal={bannerProps.name}
                    el="li"
                    className={clsx(
                      isImage && styles.hasImage,
                      isWideImage && styles.wideImage,
                      styles.bannerCol,
                    )}
                  >
                    <TileBannerContainer
                      blok={bannerProps?.content}
                      className={clsx(
                        isImage && styles.imageBanner,
                        styles.banner,
                      )}
                    />
                  </AppearanceAnimationBlock>
                )}
              </ul>
            </Container>
          </AppearanceAnimationBlock>
        ) : null}
      </AnimatePresence>
    </div>
  );
};
